import { deserialize } from 'cerialize'

export class ShortDataModel<ID = string | number, NAME = string> {
	@deserialize public id: ID
	@deserialize public name: NAME
	@deserialize public slug?: string
	@deserialize public kind?: string
	@deserialize public description?: string
	@deserialize public doubles?: string
	@deserialize public number?: string
	@deserialize public address?: string
	@deserialize public title?: string
	@deserialize public string_name?: string

	public static concatNames = (data: ShortDataModel[] = []): string => {
		return data.reduce(
			(acc: string, item: ShortDataModel): string =>
				acc && acc.length ? `${acc},  ${item.name} ` : `${item.name}`,
			''
		)
	}
	public static concatsIds = (data: { id: string | number }[] = []): string => {
		return data.reduce(
			(acc: string, item: { id: string | number }): string =>
				acc && acc.length ? `${acc},  ${item.id} ` : `${item.id}`,
			''
		)
	}
	public static getDict = (
		data: ShortDataModel[] = []
	): Record<ShortDataModel['id'], ShortDataModel> =>
		data.reduce((dict, item) => Object.assign(dict, { [item.id]: item }), {})
}
